var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "PageHeader",
        {
          staticStyle: { "padding-top": "1rem" },
          attrs: { pageTitle: "Panorama" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                gap: "1rem",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    gap: "0.5rem",
                    "align-items": "center"
                  }
                },
                [
                  _c("span", { staticStyle: { "font-size": "1rem" } }, [
                    _vm._v("De")
                  ]),
                  _vm._v(" "),
                  _c("SelectMonth", {
                    staticStyle: { "max-width": "120px" },
                    model: {
                      value: _vm.search.startMonth,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "startMonth", $$v)
                      },
                      expression: "search.startMonth"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectYear", {
                    staticStyle: { "max-width": "80px" },
                    model: {
                      value: _vm.search.startYear,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "startYear", $$v)
                      },
                      expression: "search.startYear"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-size": "1rem" } }, [
                    _vm._v("Até")
                  ]),
                  _vm._v(" "),
                  _c("SelectMonth", {
                    staticStyle: { "max-width": "120px" },
                    model: {
                      value: _vm.search.endMonth,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "endMonth", $$v)
                      },
                      expression: "search.endMonth"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectYear", {
                    staticStyle: { "max-width": "80px" },
                    model: {
                      value: _vm.search.endYear,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "endYear", $$v)
                      },
                      expression: "search.endYear"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-primary-action",
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.getAll()
                            }
                          }
                        },
                        [_vm._v("\n            Buscar\n          ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr", {
                    staticClass: "vertical-bar",
                    staticStyle: { transform: "translateY(-25%)" },
                    attrs: { "data-v-2297aafa": "" }
                  }),
                  _vm._v(" "),
                  _c("GenericSearchInput", {
                    staticStyle: { "max-width": "250px !important" },
                    attrs: { placeHolder: "Buscar" },
                    model: {
                      value: _vm.search.textSearch,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "textSearch", $$v)
                      },
                      expression: "search.textSearch"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectPanoramaInstallationStatus", {
                    staticStyle: { "max-width": "150px" },
                    model: {
                      value: _vm.search.installationStatus,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "installationStatus", $$v)
                      },
                      expression: "search.installationStatus"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectBillingStatus", {
                    staticStyle: { "max-width": "150px", "min-width": "none" },
                    model: {
                      value: _vm.search.billingStatus,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "billingStatus", $$v)
                      },
                      expression: "search.billingStatus"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectAccountManager", {
                    staticStyle: { "max-width": "150px" },
                    model: {
                      value: _vm.search.accountManagerId,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "accountManagerId", $$v)
                      },
                      expression: "search.accountManagerId"
                    }
                  }),
                  _vm._v(" "),
                  _vm.panoramaList.length
                    ? _c("SelectPromoter", {
                        staticStyle: { "max-width": "150px" },
                        attrs: { traderList: _vm.traderList },
                        model: {
                          value: _vm.search.trader,
                          callback: function($$v) {
                            _vm.$set(_vm.search, "trader", $$v)
                          },
                          expression: "search.trader"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "b-dropdown",
                        {
                          staticClass: "m-2",
                          attrs: { id: "dropdown-checkbox", text: "Campos" }
                        },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toggleAllFields()
                                }
                              }
                            },
                            [
                              Object.values(this.selectedFields).includes(false)
                                ? _c("span", [
                                    _vm._v(
                                      "\n                Marcar todos\n              "
                                    )
                                  ])
                                : _c("span", [_vm._v("Desmarcar todos")])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "p-1" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  },
                                  model: {
                                    value: _vm.selectedFields.invoiceValue,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.selectedFields,
                                        "invoiceValue",
                                        $$v
                                      )
                                    },
                                    expression: "selectedFields.invoiceValue"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Valor da fatura ($)\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "mt-2",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  },
                                  model: {
                                    value: _vm.selectedFields.qtyInvoices,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.selectedFields,
                                        "qtyInvoices",
                                        $$v
                                      )
                                    },
                                    expression: "selectedFields.qtyInvoices"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Quantidade (#)\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "mt-2",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  },
                                  model: {
                                    value: _vm.selectedFields.averageTicket,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.selectedFields,
                                        "averageTicket",
                                        $$v
                                      )
                                    },
                                    expression: "selectedFields.averageTicket"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Ticket Médio (TM)\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "mt-2",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  },
                                  model: {
                                    value: _vm.selectedFields.overallPercentage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.selectedFields,
                                        "overallPercentage",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedFields.overallPercentage"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Porcentagem vertical (V)\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "mt-2",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.selectedFields.subTotalPercentage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.selectedFields,
                                        "subTotalPercentage",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedFields.subTotalPercentage"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Porcentagem horizontal (H)\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 15,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      this.panoramaStatusSummaryList && !_vm.isLoading
        ? _c(
            "section",
            [
              _c("NewPanoramaSummaryTable", {
                attrs: {
                  panoramaStatusSummaryList: _vm.panoramaStatusSummaryList,
                  panoramaMonthsColumns: _vm.panoramaMonthsColumns,
                  selectedFields: _vm.selectedFields
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.panoramaList.length
        ? _c(
            "section",
            { staticClass: "d-flex justify-content-between flex-column" },
            [
              _c(
                "Table",
                { staticClass: "panorama-table" },
                [
                  _c(
                    "TableHeader",
                    [
                      _c(
                        "TableRow",
                        _vm._l(_vm.panoramaColumns, function(
                          panoramaCol,
                          index
                        ) {
                          return panoramaCol.visible
                            ? _c(
                                "TableHead",
                                {
                                  key: `${panoramaCol.name}_${index}`,
                                  class: panoramaCol.class,
                                  style: _vm.setInvoiceStatusColor(
                                    panoramaCol.name
                                  )
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      style:
                                        panoramaCol.key === "name"
                                          ? "display: flex; align-items: center; justify-content: space-between;"
                                          : ""
                                    },
                                    [
                                      _c("ColumnHeader", {
                                        attrs: {
                                          sort: panoramaCol.sort,
                                          somatory: panoramaCol.somatory,
                                          columnName: panoramaCol.name,
                                          columnKey: panoramaCol.key,
                                          columnType: panoramaCol.columnType,
                                          currentColumnFiltered:
                                            _vm.currentColumnFiltered,
                                          sortDirection: _vm.sortDirection,
                                          dataList: _vm.panoramaList
                                        },
                                        on: {
                                          sortListByKey: function($event) {
                                            return _vm.sortListByKey(
                                              panoramaCol.key
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      panoramaCol.key === "name"
                                        ? [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  size: "sm",
                                                  variant: "outline-secondary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleMonthsVisibility()
                                                  }
                                                }
                                              },
                                              [
                                                _vm.monthsVisible
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                    Agrupar\n                  "
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(" Desagrupar")
                                                    ])
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(_vm.panoramaList, function(panorama, index) {
                      return _c(
                        "TableRow",
                        { key: `${panorama.name}_${index}` },
                        [
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(panorama.installationNumber) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: panorama.name, maxLength: 40 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "divider",
                              style: _vm.setInstallationStatusColor(
                                panorama.installationStatus
                              )
                            },
                            [
                              _c("div", { staticStyle: { width: "105px" } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.translateInstallationStatus(
                                        panorama.installationStatus
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(Array.from(panorama.invoicesData), function(
                            invoiceData,
                            index
                          ) {
                            return _vm.monthsVisible
                              ? [
                                  _c(
                                    "TableCell",
                                    {
                                      staticClass: "money-cell",
                                      staticStyle: { "min-width": "130px" }
                                    },
                                    [
                                      invoiceData.status !== "NO_DATA"
                                        ? _c("RenderPanoramaInvoiceLine", {
                                            attrs: {
                                              "invoice-value":
                                                invoiceData.boletoVeins,
                                              "panorama-invoice-status": _vm.convertOldStatusToNewStatus(
                                                invoiceData.status
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell divider total",
                              staticStyle: {
                                "border-left": "2px solid gray !important"
                              }
                            },
                            [
                              _c("RenderPanoramaGroupedStatusColumn", {
                                attrs: {
                                  value: panorama.totalValue,
                                  qty:
                                    panorama.qtyPaidInvoice +
                                    panorama.qtyOpenInvoice +
                                    panorama.qtyAgreementInvoice +
                                    panorama.qtyOverdueInvoice +
                                    panorama.qtyLossInvoice,
                                  percent:
                                    (panorama.totalValue /
                                      panorama.totalValue) *
                                    100
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell",
                              style: _vm.setInvoiceStatusColor("[PG] Pago")
                            },
                            [
                              _c("RenderPanoramaGroupedStatusColumn", {
                                attrs: {
                                  value: panorama.totalPaidInvoiceValue,
                                  qty: panorama.qtyPaidInvoice,
                                  percent:
                                    (panorama.totalPaidInvoiceValue /
                                      panorama.totalValue) *
                                    100
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell",
                              style: _vm.setInvoiceStatusColor("[AB] Aberto")
                            },
                            [
                              _c("RenderPanoramaGroupedStatusColumn", {
                                attrs: {
                                  value: panorama.totalOpenInvoiceValue,
                                  qty: panorama.qtyOpenInvoice,
                                  percent:
                                    (panorama.totalOpenInvoiceValue /
                                      panorama.totalValue) *
                                    100
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell",
                              style: _vm.setInvoiceStatusColor("[DE] Acordo")
                            },
                            [
                              _c("RenderPanoramaGroupedStatusColumn", {
                                attrs: {
                                  value: panorama.totalAgreementInvoiceValue,
                                  qty: panorama.qtyAgreementInvoice,
                                  percent:
                                    (panorama.totalAgreementInvoiceValue /
                                      panorama.totalValue) *
                                    100
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell",
                              style: _vm.setInvoiceStatusColor(
                                "[NA] Inadimplente"
                              )
                            },
                            [
                              _c("RenderPanoramaGroupedStatusColumn", {
                                attrs: {
                                  value: panorama.totalOverdueInvoiceValue,
                                  qty: panorama.qtyOverdueInvoice,
                                  percent:
                                    (panorama.totalOverdueInvoiceValue /
                                      panorama.totalValue) *
                                    100
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              staticClass: "money-cell divider",
                              style: _vm.setInvoiceStatusColor("[RD] Perda")
                            },
                            [
                              _c("RenderPanoramaGroupedStatusColumn", {
                                attrs: {
                                  value: panorama.totalLossInvoiceValue,
                                  qty: panorama.qtyLossInvoice,
                                  percent:
                                    (panorama.totalLossInvoiceValue /
                                      panorama.totalValue) *
                                    100
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              panorama.accountManagerName
                                ? _c("RenderNameColumnValue", {
                                    attrs: { name: panorama.accountManagerName }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              panorama.traderName
                                ? _c("RenderNameColumnValue", {
                                    attrs: { name: panorama.traderName }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: {
                                  "social-number": panorama.socialNumber
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : !_vm.isLoading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }